import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/stores/authStore'

const TIMEOUT_MS = 2 * 60 * 60 * 1000 // 2 hours

/**
 * Auto-logout after 2 hours of inactivity.
 * Only use inside the authenticated layout (not on login page).
 */
export function useSessionTimeout() {
  const timerRef = useRef<ReturnType<typeof setTimeout>>()
  const logout = useAuthStore((s) => s.logout)

  useEffect(() => {
    const resetTimer = () => {
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(logout, TIMEOUT_MS)
    }

    const events = ['mousedown', 'keydown', 'touchstart', 'scroll']
    events.forEach((e) => window.addEventListener(e, resetTimer))
    resetTimer()

    return () => {
      clearTimeout(timerRef.current)
      events.forEach((e) => window.removeEventListener(e, resetTimer))
    }
  }, [logout])
}
